interface StepIndicatorProps {
  currentStep: number;
}

const steps = [
  { id: 1, label: "Chọn dịch vụ", icon: "ri-service-line" },
  { id: 2, label: "Chọn ngày giờ", icon: "ri-calendar-line" },
  { id: 3, label: "Thông tin", icon: "ri-user-line" },
];

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  return (
    <div className="flex items-center justify-center gap-2 md:gap-4">
      {steps.map((step, index) => (
        <div key={step.id} className="flex items-center gap-2 md:gap-4">
          <div className="flex flex-col items-center gap-2">
            <div
              className={`w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-full border-2 transition-colors ${
                currentStep >= step.id
                  ? "bg-primary-500 border-primary-500 text-background-50"
                  : "bg-background-50 border-background-300 text-foreground-400"
              }`}
            >
              <i className={`${step.icon} text-base md:text-lg`} />
            </div>
            <span
              className={`text-xs font-label font-medium whitespace-nowrap ${
                currentStep >= step.id ? "text-primary-700" : "text-foreground-400"
              }`}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`hidden sm:block w-12 md:w-24 h-0.5 -mt-6 rounded-full ${
                currentStep > step.id ? "bg-primary-500" : "bg-background-300"
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
}